export default __webpack_public_path__ + "static/media/dieppe18.39d293d3.jpg";